module.exports = __webpack_public_path__ + "img/788.90c7af37.jpg";